import cases from '../data/cases/participantList.json';

export const getAllParticipants = () => {
    return cases['data'];
};